import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
export function EquipmentSection({ equipment }) {
    const [checkedEquipment, setCheckedEquipment] = useState(new Set());
    // Normalize equipment to strings for display and tracking
    const normalizeEquipment = (item) => {
        return typeof item === 'string' ? item : item.tool;
    };
    const equipmentList = equipment.map(normalizeEquipment);
    const toggleEquipment = (item) => {
        setCheckedEquipment((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(item)) {
                newSet.delete(item);
            }
            else {
                newSet.add(item);
            }
            return newSet;
        });
    };
    if (equipmentList.length === 0)
        return null;
    return (_jsxs("div", { className: "bg-[#faf8f5] border border-[#e8e3db] rounded-lg p-6 recipe-print-section recipe-print-equipment", children: [_jsx("h2", { className: "mb-4 text-[#5a4a3a]", children: "Equipment" }), _jsx("ul", { className: "space-y-3", children: equipmentList.map((item, index) => {
                    const itemId = `equipment-${index}`;
                    const isChecked = checkedEquipment.has(item);
                    // Get the original item to access role/alternatives if needed
                    const originalItem = equipment[index];
                    const hasDetails = typeof originalItem === 'object' && (originalItem.role || (originalItem.alternatives && originalItem.alternatives.length > 0));
                    return (_jsxs("li", { className: "flex items-start gap-3", children: [_jsx(Checkbox, { id: itemId, checked: isChecked, onCheckedChange: () => toggleEquipment(item), className: "mt-0.5 flex-shrink-0 no-print" }), _jsxs("label", { htmlFor: itemId, className: `flex-1 cursor-pointer transition-all ${isChecked
                                    ? "line-through text-[#5a4a3a]/50"
                                    : "text-[#5a4a3a]"}`, title: typeof originalItem === 'object' && originalItem.role ? originalItem.role : undefined, children: [item, hasDetails && (_jsx("span", { className: "ml-2 text-xs text-[#5a4a3a]/50", children: "\u2139\uFE0F" }))] })] }, itemId));
                }) })] }));
}
